const CoffeeSearch = () => {
  return (
    <div className='coffee__header'>
      <h2 className='coffee__header-title'>Coffee</h2>
    </div>
  )
}

export default CoffeeSearch
